export default __webpack_public_path__ + "static/media/punotes.ad27ff58.JPG";